import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';

import { StateType } from '../../../reducers';
import { getUserPermissionsSelector } from '../../../reducers/AuthenticationReducer/AuthenticationSelector';
import { leaderboardSelector } from '../../../reducers/LeaderboardReducer/LeaderboardSelector';
import { consultantPerformanceLeaderboardSelector } from '../../../reducers/ProfileReducer/UserReducer/UserProfileSelector';
import { getLanguageCode } from '../../../shared/helpers';
import { Card } from '../../Card';
import { CardList } from '../../Card/CardList';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { ConsultantLeaderboardPropsGenericType, ConsultantLeaderboardStateProps } from './types';
import { formatMessageHelper } from '../../../shared/helpers/internationalization';

const ConsultantLeaderboard = (props: ConsultantLeaderboardPropsGenericType & InjectedIntlProps) => {
  const { profileLeaderboard, userPermissions, intl } = props;

  const isConsultant = userPermissions.includes('CONSULTANT');

  const leaderboardData = profileLeaderboard?.get(0);

  if (!leaderboardData || !isConsultant) {
    return null;
  }

  const cellValue = (value: any, localize: boolean) =>
    value || value === 0 ? (localize ? value.toLocaleString(getLanguageCode()) : value) : '';

  return (
    <Grid.Column tablet={8} mobile={16} computer={5}>
      <Card title={formatMessageHelper(intl, 'consultant.leaderboard.title')} modifiers={['full']}>
        <CardList>
          <CardList.Title>{formatMessageHelper(intl, 'consultant.leaderboard.stats')}</CardList.Title>
          <CardList.Row>
            <CardList.Cell>{formatMessageHelper(intl, 'consultant.leaderboard.weightFactor')}</CardList.Cell>
            <CardList.Cell modifiers={['cap']}>{cellValue(leaderboardData.get('weightFactor'), true)}</CardList.Cell>
          </CardList.Row>
          <CardList.Row>
            <CardList.Cell modifiers={['cap']}>{formatMessageHelper(intl, 'consultant.leaderboard.valueFactor')}</CardList.Cell>
            <CardList.Cell>{cellValue(leaderboardData.get('valueFactor'), true)}</CardList.Cell>
          </CardList.Row>
          <CardList.Row>
            <CardList.Cell>{formatMessageHelper(intl, 'consultant.leaderboard.usedFields')}</CardList.Cell>
            <CardList.Cell>{cellValue(leaderboardData.get('dataFieldsUsed'), false)}</CardList.Cell>
          </CardList.Row>
          <CardList.Row>
            <CardList.Cell>{formatMessageHelper(intl, 'consultant.leaderboard.submittedAlphas')}</CardList.Cell>
            <CardList.Cell>{cellValue(leaderboardData.get('submissionsCount'), false)}</CardList.Cell>
          </CardList.Row>
        </CardList>
      </Card>
    </Grid.Column>
  );
};

const mapStateToProps = (state: StateType): ConsultantLeaderboardStateProps => ({
  // @ts-ignore
  profileLeaderboard: leaderboardSelector(state),
  // @ts-ignore
  userProfileLeaderboard: consultantPerformanceLeaderboardSelector(state),
  // @ts-ignore
  userPermissions: getUserPermissionsSelector(state),
});

export default injectIntl(
  withRouter(connect<ConsultantLeaderboardStateProps, {}, {}, StateType>(mapStateToProps, {})(ConsultantLeaderboard))
);
